import { ResendConfirmUserEmailPayload } from 'app/api/resendConfirmUserEmail'
import * as Yup from 'yup'

export type ResendConfirmUserEmailFormData = {
  email: string
}

export const resendConfirmUserEmailDefaultValues: ResendConfirmUserEmailFormData =
  {
    email: '',
  }

export const resendConfirmUserEmailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Formato non valido')
    .required('Campo obbligatorio'),
})

export const adaptFormDataToAPI = (
  formData: ResendConfirmUserEmailFormData
): ResendConfirmUserEmailPayload => ({
  api_v1_user: {
    email: formData.email,
  },
})
